import { useDataFormStore } from "@/stores/form";
import { checkDayToDay } from "@/utils/changeDate";
import { getArrayOfRules } from "@/utils/getDataForm";
import { inject, ref } from 'vue';

export default {
  setup() {
    const dataForm = useDataFormStore();

    const ruleFormRef = inject('ruleFormRef', {});

     const cityFromRestrictions = inject('cityFromRestrictions');
     const cityToRestrictions = inject('cityToRestrictions');

    const dialogBadDimensionsInfo = ref({maxHeight: -1, maxWeight: -1, maxSize: -1, open: false});

    const typeOfCargos = [
      {
        value: "Стандарт",
        label: "Стандарт",
      },
      {
        value: "Цилиндры",
        label: "Цилиндры",
      },
      {
        value: "Шины",
        label: "Шины",
      },
    ];
    const typeOfPackagings = [
      {
        value: "Обрешётка",
        label: "Обрешётка",
        disabled: [
          "Обрешётка",
          "Стретч-пленка",
          "Коробка 25x18x10",
          "Коробка 38x30x23",
          "Пакет",
        ],
      },
      {
        value: "Паллетирование",
        label: "Паллетирование",
        disabled: [
          "Паллетирование",
          "Стретч-пленка",
          "Коробка 25x18x10",
          "Коробка 38x30x23",
          "Пакет",
        ],
      },
      {
        value: "Стретч-пленка",
        label: "Стретч-пленка",
        disabled: [
          "Обрешётка",
          "Паллетирование",
          "Стретч-пленка",
          "Коробка 25x18x10",
          "Коробка 38x30x23",
          "Пакет",
          "Поддон",
        ],
      },
      {
        value: "Коробка 25x18x10",
        label: "Коробка 25x18x10",
        disabled: [
          "Обрешётка",
          "Паллетирование",
          "Стретч-пленка",
          "Коробка 25x18x10",
          "Поддон",
        ],
      },
      {
        value: "Коробка 38x30x23",
        label: "Коробка 38x30x23",
        disabled: [
          "Обрешётка",
          "Паллетирование",
          "Стретч-пленка",
          "Коробка 38x30x23",
          "Поддон",
        ],
      },
      {
        value: "Пакет",
        label: "Пакет",
        disabled: ["Обрешётка", "Паллетирование", "Стретч-пленка", "Пакет"],
      },
      {
        value: "Поддон",
        label: "Поддон",
        disabled: [
          "Стретч-пленка",
          "Коробка 25x18x10",
          "Коробка 38x30x23",
          "Пакет",
          "Поддон",
        ],
      },
    ];

    function checkIntersectionsTypes(types, typeName) {
      return !(
        dataForm.cargoInformation.typeOfPackaging.filter((type) =>
          types.includes(type)
        ).length === dataForm.cargoInformation.typeOfPackaging.length &&
        checkWarmPlace(typeName)
      );
    }

    function checkWarmPlace(typeName) {
      if (!dataForm.services.warmPlace) {
        return true;
      }
      return typeName === "Паллетирование" || typeName === "Поддон"
        ? false
        : true;
    }

    function handlerWeight() {
      if (
        
        checkDayToDay(dataForm.applicationCargoPickup.pickupDate) &&
        checkHour() &&
        checkWeight() &&
        checkCity()
      ) {
        dataForm.cargoInformation.cargoWeight = 30;
      }
      dataForm.updateApplicationTimeIsOver()
    }

    const checkCity = () =>
      dataForm.sender.cityFrom === "Челябинск" ||
      dataForm.sender.cityFrom === "Екатеринбург";

    const checkWeight = () => dataForm.cargoInformation.cargoWeight > 30;

    const checkHour = () => new Date().getHours() >= 12;

    return {
      dataForm,
      typeOfCargos,
      typeOfPackagings,
      dialogBadDimensionsInfo,
      checkIntersectionsTypes,
      getArrayOfRules,
      checkDayToDay,
      checkHour,
      checkWeight,
      checkCity,
      handlerWeight,
      cityFromRestrictions,
      cityToRestrictions,

      checkNumberOfIdenticalLoads: function () {
        if (dataForm.cargoInformation.numberOfIdenticalLoads < 1) {
          dataForm.cargoInformation.numberOfIdenticalLoads = 1;
        }
      },

      checkCargoCost: function () {
        if (dataForm.cargoInformation.cargoCost < 3000) {
          dataForm.cargoInformation.cargoCost = 3000;
        }
        if (dataForm.cargoInformation.cargoCost >= 30000) {
          // dataForm.cargoInformation.additionalPackaging = true
          // if (!dataForm.cargoInformation.typeOfPackaging.includes('Обрешётка')) {
          //   dataForm.cargoInformation.typeOfPackaging.push('Обрешётка')
          // }
        }
      },

      checkPackageType: function () {
        if (dataForm.cargoInformation.cargoCost >= 30000) {
          // if (!dataForm.cargoInformation.typeOfPackaging.includes('Обрешётка')) {
          //   dataForm.cargoInformation.typeOfPackaging.push('Обрешётка')
          // }
          // console.log(dataForm.cargoInformation.typeOfPackaging)
        }
      },

      checkValidityDimension: function (value, dimension) {
        const maxHeight = Math.min(cityFromRestrictions.value?.maxAcceptedShippingHeight || Infinity, cityToRestrictions.value?.maxAcceptedHeight || Infinity);
        const maxWeight = Math.min(cityFromRestrictions.value?.maxAcceptedShippingWeight || Infinity, cityToRestrictions.value?.maxAcceptedWeight || Infinity);
        const maxSize = Math.min(cityFromRestrictions.value?.maxAcceptedShippingSize || Infinity, cityToRestrictions.value?.maxAcceptedSize || Infinity);
        const resetDimensions = () => {
          dataForm.cargoInformation.cargoDimensions.length = '';
          dataForm.cargoInformation.cargoDimensions.width = '';
          dataForm.cargoInformation.cargoDimensions.height = '';
          dataForm.cargoInformation.sizeOfCargoCylinder.height = '';
          dataForm.cargoInformation.sizeOfCargoCylinder.diameter = '';
          dataForm.cargoInformation.cargoWeight = '';
          dataForm.cargoInformation.cargoVolume = '';
        };
        switch (dimension) {
          case 'height':
            if (Number(value) > maxHeight) {
              dialogBadDimensionsInfo.value.open = true;
              dialogBadDimensionsInfo.value.maxHeight = maxHeight
              dialogBadDimensionsInfo.value.maxWeight = -1
              dialogBadDimensionsInfo.value.maxSize = -1
              resetDimensions();
              console.log('Height is too big!');
            }
            break;
          case 'weight':
            if (Number(value) > maxWeight) {
              dialogBadDimensionsInfo.value.open = true;
              dialogBadDimensionsInfo.value.maxWeight = maxWeight;
              dialogBadDimensionsInfo.value.maxHeight = -1;
              dialogBadDimensionsInfo.value.maxSize = -1;
              resetDimensions();
              console.log('Weight is too big!');
            }
            break;
          case 'size':
            if (Number(value) > maxSize) {
              dialogBadDimensionsInfo.value.open = true;
              dialogBadDimensionsInfo.value.maxSize = maxSize;
              dialogBadDimensionsInfo.value.maxHeight = -1;
              dialogBadDimensionsInfo.value.maxWeight = -1;
              resetDimensions();
              console.log('Size is too big!');
            }
            break;
        }
      },

      toggleTypePackaging: function (value) {
        if (!value) {
          ruleFormRef.value.resetFields(['cargoInformation.typeOfPackaging']);
        }
      },

      calculateVolume: function () {
        if (dataForm.cargoInformation.cargoDimensions.length && dataForm.cargoInformation.cargoDimensions.width && dataForm.cargoInformation.cargoDimensions.height) {
          dataForm.cargoInformation.cargoVolume =
            (dataForm.cargoInformation.cargoDimensions.length * dataForm.cargoInformation.cargoDimensions.width * dataForm.cargoInformation.cargoDimensions.height) / 1000000;
        }
      },

      calculateDimensions: function () {
        const size = Math.round(Math.cbrt(Number(dataForm.cargoInformation.cargoVolume) * 1000000)).toFixed(0);
        dataForm.cargoInformation.cargoDimensions.length = size;
        dataForm.cargoInformation.cargoDimensions.width = size;
        dataForm.cargoInformation.cargoDimensions.height = size;
      },
    };
  },
};
